import { useState } from 'react'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import { useSelector } from 'react-redux'

import { _object } from 'utils/interfaces'

import { Button, InputField } from 'components/form-inputs'

import { ModalCloseIcon } from 'assets/svg'

const ProfileEdit = () => {
  const { loggedInUser } = useSelector((state: _object) => state.session)
  const [loading, setLoading] = useState(false)

  const validationSchema = Yup.object({
    first_name: Yup.string().label('First name').required(),
    last_name: Yup.string().label('Last name').min(4).required(),
    email: Yup.string().label('Email').required()
  })
  const formik: any = useFormik({
    initialValues: {
      first_name: loggedInUser?.first_name || '',
      last_name: loggedInUser?.last_name || '',
      email: loggedInUser?.email || '',
      password: ''
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: () => {
      setLoading(true)
      // authService.register(values).then((results: any) => {
      //   setLoading(false)
      // })
    }
  })
  return (
    <>
      <div className="modal-dialog modal-dialog-centered relative z-10 max-h-full w-full max-w-2xl">
        <div className="modal-content relative rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
          <button className="absolute top-5 right-5" data-modal-hide="profile-edit-modal">
            <ModalCloseIcon className="h-6 w-6" />
          </button>
          <div className="flex items-center justify-between border-b border-gray-200 p-3 px-5">
            <h4>Account Settings</h4>
          </div>

          <form onSubmit={formik.handleSubmit} className="mt-5 space-y-8">
            <div>
              <label className="font-semibold text-black">Name</label>
              <p className="mb-3 text-gray-700">This is the name you used when you signed up</p>

              <InputField
                name="first_name"
                type="text"
                placeholder="First name"
                onBlur={formik.handleBlur}
                value={formik.values.first_name}
                onChange={formik.handleChange}
                required={true}
                error={formik.touched.first_name && formik.errors.first_name}
              />

              <InputField
                name="last_name"
                type="text"
                placeholder="Last name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.last_name}
                error={formik.touched.last_name && formik.errors.last_name}
                required={true}
              />
            </div>
            <InputField
              name="password"
              type="password"
              placeholder="Password"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.password}
              required={true}
              error={formik.touched.password && formik.errors.password}
            />
            <div>
              <label className="font-semibold text-black">Email</label>
              <p className="mb-3 text-gray-700">
                This is the e-mail account that your link is associated to
              </p>

              <InputField
                name="email"
                type="email"
                placeholder="Email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                required={true}
                error={formik.touched.email && formik.errors.email}
              />
            </div>

            <Button
              label="Save Changes"
              type="submit"
              className="w-full rounded-md bg-purple-900 hover:bg-purple-950"
              loading={loading}
            />
          </form>
        </div>
      </div>
    </>
  )
}

export default ProfileEdit
